
import React, { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';


import NawigacjaGora from '../../Nav';
import OpadajacaStrona from '../../OpadajacaStrona';
import AboutUpSection from '../UpSection';
import Zaslona from '../../Zanimowane/Zaslona';
import Heading from './Heading';
import OpisHeadingu from './OpisHeadingu';
import ObrazekBezAni from '../../Nie-Animowane/ObrazekBezAni';
import Footer from '../Footer';

import SekcjaPasja from './SekcjaPasja';
import SekcjaSkills from './SekcjaSkills';

import { opisy } from '../../../data/Opisy';

const About = () => {

    const [menuState, setMenuState] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1300);

    const handleMenu = () => {
        setMenuState(!menuState);
        console.log(menuState);
    };

    const { ref, inView } = useInView();

    const pageVariants = {
        initial: {
            opacity: 1,
        },
        in: {
            opacity: 1,
        },
        out: {
            opacity: 1,
        },
    };

    const pageTransition = {
        type: 'tween',
        ease: 'anticipate',
        duration: 1.0,
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 1300);
        };
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);



    return (
        <div id="about-main" className=''>

            <motion.div
                initial="initial"
                animate="in"
                exit="out"
                variants={pageVariants}
                transition={pageTransition}
            >
                <OpadajacaStrona isVisible={menuState} />
                <NawigacjaGora stanMenu={menuState} zmienMenu={handleMenu} czyCzarnyTekst={inView ? false : true} />
                <Zaslona />

                <div ref={ref} className='h-screen w-full bg-[#061e3d]'>
                    <AboutUpSection czyZanimowane={false} inView={inView}
                        przycisk={true} obrazek={"fala2.jpg"} tytul={"About me"} text={"Something about me and my skills"} />
                </div>

                <div>
                    <div className='relative top-72 '>
                        <Heading numerSekcji={"01"} tytul={"WHO I AM"} />
                        <div className='flex items-center justify-evenly'>
                            <div></div>
                            <div className='mr-20'>
                                <OpisHeadingu glowneStyle={isMobile ? 'max-w-sm ml-16' : 'max-w-2xl ml-16'} tytul={"Jakub Bednarek"} opis={opisy[0]} fontSize={"xl"}>
                                    <ObrazekBezAni cover={false} inneStyle={true} stylizacja={'relative top-[3rem] w-full h-[500px] rounded-md drop-shadow-[0_35px_35px_rgba(0,0,0,0.35)]'} src="me2.jpg" />
                                </OpisHeadingu>
                            </div>
                        </div>
                    </div>

                    <div className='flex flex-col'>
                        <SekcjaPasja />
                        <SekcjaSkills />
                        <div></div>
                        <Footer margin={""} />
                    </div>



                </div>


            </motion.div>
        </div>
    );
}

export default About;
